export default __webpack_public_path__ + "static/media/G0905.G0900_1.1719486180000.67727282.jpg";